export const CartActionsTypes = {
  TOGGLE_CART_HIDDEN: "TOGGLE_CART_HIDDEN",
  ADD_ITEM: "ADD_ITEM",
  REMOVE_ITEM: "REMOVE_ITEM",
  CLEAR_ITEM: "CLEAR_ITEM",
  CLEAR_CART: "CLEAR_CART",

  UPDATE_CART_IN_FIREBASE_START: "UPDATE_CART_IN_FIREBASE_START",
  UPDATE_CART_IN_FIREBASE_SUCCESS: "UPDATE_CART_IN_FIREBASE_SUCCESS",
  UPDATE_CART_IN_FIREBASE_FAILURE: "UPDATE_CART_IN_FIREBASE_FAILURE",

  GET_CART_FROM_FIREBASE_START: "GET_CART_FROM_FIREBASE_START",
  GET_CART_FROM_FIREBASE_SUCCESS: "GET_CART_FROM_FIREBASE_SUCCESS",
  GET_CART_FROM_FIREBASE_FAILURE: "GET_CART_FROM_FIREBASE_FAILURE",
};
